import { api, unwrap } from '@saas-kit/lib';

export interface Role {
  id: string;
  tenant_id: string;
  slug: string;
  name: string;
  description: string | null;
  is_system: boolean;
  is_default: boolean;
}

export interface PermissionRow {
  key: string;
  module: string;
  description: string;
  assignable: boolean;
}

interface ListEnvelope<T> {
  items: T[];
}

export async function listRoles(): Promise<Role[]> {
  const data = await unwrap<ListEnvelope<Role>>(api.get('/roles'));
  return data.items;
}

export async function createRole(input: {
  name: string;
  slug: string;
  description: string | null;
}): Promise<Role> {
  return unwrap<Role>(api.post('/roles', input));
}

export async function updateRole(
  roleId: string,
  input: { name?: string; slug?: string; description?: string | null },
): Promise<Role> {
  return unwrap<Role>(api.patch(`/roles/${roleId}`, input));
}

export async function deleteRole(roleId: string): Promise<void> {
  await api.delete(`/roles/${roleId}`);
}

export async function listPermissions(): Promise<PermissionRow[]> {
  const data = await unwrap<ListEnvelope<PermissionRow>>(api.get('/permissions'));
  return data.items;
}

export async function listRolePermissions(roleId: string): Promise<PermissionRow[]> {
  const data = await unwrap<ListEnvelope<PermissionRow>>(
    api.get(`/roles/${roleId}/permissions`),
  );
  return data.items;
}

export async function attachRolePermission(
  roleId: string,
  permissionKey: string,
): Promise<void> {
  await api.post(`/roles/${roleId}/permissions`, {
    permission_key: permissionKey,
  });
}

export async function detachRolePermission(
  roleId: string,
  permissionKey: string,
): Promise<void> {
  await api.delete(`/roles/${roleId}/permissions/${permissionKey}`);
}
